"use client";

import { FunctionComponent, MouseEvent } from "react";
import { ActiveLink } from "../active-link/active-link";

export interface LinkProps {
    /**
     * Children of the link.
     */
    children: React.ReactNode;

    /**
     * URL of the link.
     */
    href: string;

    /**
     * The classname(s) which will be applied when the link is active.
     */
    activeClassName?: string;

    /**
     * A callback function which will be fired on click to an anchor link.
     */
    handleAnchorClick?: () => void;

    /**
     * A callback function which will be fired onMouseEnter.
     */
    onMouseEnter?: (event: MouseEvent<HTMLElement>) => void;

    /**
     * A callback function which will be fired onMouseLeave.
     */
    onMouseLeave?: (event: MouseEvent<HTMLElement>) => void;

    /**
     * The target of the link.
     */
    target?: "_self" | "_blank";

    /**
     * Class name of the link.
     */
    className?: string;
}

export const Link: FunctionComponent<LinkProps> = ({ children, target, className, ...restProps }) => {
    const { handleAnchorClick, ...domLinkProps } = restProps;
    const CustomTag = target === "_blank" ? "a" : ActiveLink;
    const customProps = target === "_blank" ? domLinkProps : restProps;

    return (
        <CustomTag className={`group ${className || ""}`.trim()} target={target} {...customProps}>
            {children}
        </CustomTag>
    );
};
